export const PRODUCTION_API_DOMAIN = 'app.teamcaredental.com';
export const server = process.env.REACT_APP_API_ENDPOINT || '';

// ─── Routes ──────────────────────────────────────────────────────────────
export const PORTAL_ROUTES = {
  ROOT: '/portal',
  DASHBOARD: '/portal/dashboard',
  APPOINTMENTS: '/portal/appointments',
  CONVERSATIONS: '/portal/conversations',
  BILLING: '/portal/billing',
  CHARGES: '/portal/billing/charge',
  TREATMENT_PLANS: '/portal/treatment_plans',
  MEMBERSHIP: '/portal/membership',
  PROFILE: '/portal/profile',
  INSURANCE: '/portal/profile/insurance',
  MEDICAL: '/portal/profile/medical',
  TREATMENT_CONSENTS: '/portal/profile/treatment-consents',
  SETTINGS: '/portal/settings',
} as const;

// ─── Resource types ──────────────────────────────────────────────────────
// These appear as both URL segments under /:resourceType/:encodedResourceId
// and as `resource_type` values sent to the backend during DOB auth.
export const PORTAL_RESOURCE_TYPES = {
  APPOINTMENTS: 'appointments',
  PATIENTS: 'patients',
  CONVERSATIONS: 'conversations',
  TREATMENT_PLANS: 'treatment_plans'
} as const;

export type PortalResourceType =
  typeof PORTAL_RESOURCE_TYPES[keyof typeof PORTAL_RESOURCE_TYPES];

// ─── Appointment status (raw backend values) ─────────────────────────────
export const APPOINTMENT_STATUS = {
  SCHEDULED: 'scheduled',
  CANCELLED: 'cancelled',
  COMPLETED: 'completed',
  UNSCHEDULED: 'unscheduled',
} as const;

export type AppointmentStatus =
  typeof APPOINTMENT_STATUS[keyof typeof APPOINTMENT_STATUS];

// ─── Branding / UI ───────────────────────────────────────────────────────
// SyncLoader takes a hex; mirrors `teamcare-blue` in tailwind.config.js.
export const BRAND_LOADER_COLOR = '#4A90E2';

// ─── Events ──────────────────────────────────────────────────────────────
// The sidebar's membership link sits outside the panel that knows about the
// membership, so the panel announces changes on the window instead.
export const MEMBERSHIP_CHANGED = 'membership:changed';

// ─── Timing ──────────────────────────────────────────────────────────────
// How often the "Next Appointment" countdown re-renders. One minute is
// enough precision for "in 3h 12m"-style display.
export const COUNTDOWN_TICK_MS = 60_000;

// ─── External services ───────────────────────────────────────────────────
export const EXTERNAL_URLS = {
  GOOGLE_CALENDAR_RENDER: 'https://calendar.google.com/calendar/render',
  GOOGLE_MAPS_SEARCH: 'https://www.google.com/maps/search/',
} as const;
